module.exports = __webpack_public_path__ + "img/angle-right.614c3645.svg";